import BaseService from './BaseService'
import * as apiroutes from '../apiRoutes'

class JournalistsService extends BaseService {
    constructor() {
        super(apiroutes.JOURNALISTS)
    }

    // Output-specific methods
    async create(data) {
        // Validate required fields
        /*     const requiredFields = ['description', 'dli_id']
            const missingFields = requiredFields.filter(field => !data[field])
            
            if (missingFields.length > 0) {
                return {
                    success: false,
                    error: `Missing required fields: ${missingFields.join(', ')}`,
                    message: `Missing required fields: ${missingFields.join(', ')}`
                }
            }
     */
        return await super.create(data)
    }

    async update(id, data) {
        return await super.update(id, data)
    }

    async delete(id) {
        return await super.delete(id)
    }

    async get(params = {}) {
        return await super.getAll(params)
    }
    async getAll(params = {}) {
        return await super.customCall("GET", '', null, params, null)
    }
    async getFromPost(params = {}) {
        return await super.getByPost(params)
    }

    async getById(id) {
        return await super.getById(id)
    }

    async search(searchTerm, filters = {}) {
        return await super.search(searchTerm, filters)
    }

    async bulkUpdate(ids, updateData) {
        return await super.bulkUpdate(ids, updateData)
    }

    async bulkDelete(ids) {
        return await super.bulkDelete(ids)
    }

    async export(format = 'csv', filters = {}) {
        return await super.export(format, filters)
    }

    async updateStatus(id, data) {
        return await super.updateStatusByPut(id, data)
    }



}

// Create instance and export it
const JournalistsServices = new JournalistsService()
export default JournalistsServices